(function() {
  // Only proceed if the custom element isn't already defined
  if (customElements.get('shipping-calculator')) {
    return; // Exit if already defined
  }

  class ShippingCalculator extends HTMLElement {
    constructor() {
      super();
      this.instanceId = this.getAttribute('data-instance-id');
    }

    connectedCallback() {

      // Add your conditions here to enable the tabs
      this.enableTabs();
      
      if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", (e) => this.reinitializeSection(e.detail.sectionId));
      }
    }

    initTabs() {
      const tabs = this.querySelectorAll(".calc_tabs li");
      tabs.forEach((tab) => {
        tab.addEventListener("click", (e) => {
          e.preventDefault();
          this.clearActive();
          this.activateTab(tab);
        });
      });

      // Ensure at least one tab is active on load
      if (!this.querySelector(".calc_tabs li.is-active")) {
        const firstTab = this.querySelector(".calc_tabs li");
        if (firstTab) this.activateTab(firstTab);
      }
    }

    clearActive() {
      this.querySelectorAll(".calc_tabs li, .calc_tab-content").forEach((el) => el.classList.remove("is-active"));
    }

    activateTab(tab) {
      tab.classList.add("is-active");
      const href = tab.querySelector("a").getAttribute("href");
      const content = this.querySelector(href);
      if (content) content.classList.add("is-active");
    }

    reinitializeSection(sectionId) {
      const section = document.querySelector(`#calc_tabs-section-${sectionId}`);
      if (section) this.initTabs.call(section);
    }

    enableTabs() {
      //this.removeAttribute("hidden");
      this.initTabs();
    }
  }
  customElements.define("shipping-calculator", ShippingCalculator);


  let globalInstanceId = null;
  let calculateBtn = null; //document.getElementById('calculate-shipping');
  let calculateBtns = document.querySelectorAll('.calculate-shipping');
  let postCode = document.getElementById('estimate_postcode');
  let postCodes = document.querySelectorAll('.estimate_postcode');

  let dataEl = document.querySelector('[data-component-product]');
  let productData = dataEl ? JSON.parse(dataEl.textContent) : {};
  let baseUrl = `https://shopping-dfg.directfitnessgear.com.au`;
  var arrowIcon = `<svg focusable="false" viewBox="0 0 24 24" width="24" height="24" class="pip-svg-icon pip-section__icon pip-section__icon--right" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="m15.5996 12.0007-5.785 5.7857-1.4143-1.4141 4.3711-4.3716L8.4003 7.629l1.4143-1.4142 5.785 5.7859z"></path></svg>`;            
  var eyeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z"></path></svg>`;
  var deliveryIcon = ``;
  var collapseDownIcon = `<svg focusable="false" width="12" height="8" class="icon icon--chevron icon--inline  " viewBox="0 0 12 8"><path fill="none" d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.1"></path></svg>`;
  var parentPickupIcon = `<svg focusable="false" viewBox="0 0 24 24" width="24" height="24" class="pip-svg-icon pip-section__icon" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 4v16h20V4H2zm2 4V6h16v2H4zm0 2v8h3v-6h10v6h3v-8H4zm11 4h-2v4h2v-4zm-4 0H9v4h2v-4z"></path></svg>`;
  var cautionIcon = `<span class="pickup-unavailable transfer on-order-tooltip">
                        <span class="ttooltip">This is a warehouse pick up location only. It is not a store and no products are on display.</span>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 6C12.5523 6 13 6.44772 13 7V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V7C11 6.44772 11.4477 6 12 6Z" fill="currentColor" /><path d="M12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z" fill="currentColor" /><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z" fill="currentColor" /></svg>
                      </span>`;
  var noDeliveryMessage = 'Sorry, there was no delivery or pick up option available for your postcode. <a href="/contact">Contact us</a> now for a shipping rate.';
  let lastRequest = {
    url: null,
    body: null,
    timestamp: null
  };
  const REQUEST_DEBOUNCE_MS = 1000;


  function calculatorGetRandomNumber(min = 0, max = 1) {
    // If only one argument is provided, treat it as the max
    if (arguments.length === 1) {
        max = min;
        min = 0;
    }
    
    // Ensure min and max are numbers
    min = Number(min);
    max = Number(max);
    
    // Swap min and max if they're in the wrong order
    if (min > max) {
        [min, max] = [max, min];
    }
    
    // Generate and return the random number
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }


  function getPrice(selector, context) {
    const priceElement = document.querySelector(selector);
    var price = "";
    if (priceElement) {
        const priceText = priceElement.textContent.trim();
        price = parseFloat(priceText.replace(/[^0-9.]/g, ''));
        console.log(`${context} Price:`, price);
    } else {
        console.log(`Price element not found in ${context}`);
    }
    return price;
  }

  function eventDelivery(event) {
    event.preventDefault();
    //const deliveryWrap = document.querySelector('[data-delivery-wrap]');
    const deliveryFormContent = event.target.closest('.delivery-form__content');
    let deliveryWrap = null;
    if (deliveryFormContent) {
      deliveryWrap = deliveryFormContent.querySelector('[data-delivery-wrap]');
    }
    postCode = deliveryFormContent.querySelector('.estimate_postcode');
    const deliveryForm = event.target.closest('.delivery-form');
    const deliveryProducts = document.querySelectorAll('.buy-buttons-block product-form-component');
    const products = {products: []};
    const instanceId = deliveryForm.getAttribute('data-instance-id');
    globalInstanceId = instanceId;

    // Check for price in product page
    //productPrice = getPrice('.product-meta__price-list-container .price--large', 'Product Page');
    productPrice = document.querySelector('.delivery-form.with-product-price').getAttribute('data-product-price');

    // Check for price in cart page
    cartPrice = getPrice('.cart__total-container text-component[ref="cartTotal"]', 'Cart Page');


    


    if (deliveryProducts.length === 0 || document.querySelector('cart-items-component')) { // cart page or cart drawer
      const deliveryCartProducts = document.querySelectorAll('.cart-items tr[ref="cartItemRows[]"]');
      deliveryCartProducts.forEach(item => {
        const productId = item.getAttribute('data-product-id');
        const variantId = item.getAttribute('data-variant-id');
        const productPrice = item.getAttribute('data-product-price');
        const productQty = item.querySelector('quantity-selector-component input[name="updates[]"]') ? item.querySelector('quantity-selector-component input[name="updates[]"]').value : 1;
        const product = {
          id: productId,
          variantId: variantId,
          quantity: productQty,
          productPrice: productPrice,
          cartPrice: cartPrice
        }
        products.products.push(product);
      });
    } else { // product page
      deliveryProducts.forEach(item => {
        const productId = item.getAttribute('data-product-id');
        const variantIdInput = item.querySelector('input[ref="variantId"]');
        const variantId = variantIdInput ? variantIdInput.value : item.getAttribute('data-delivery-variant');
        const productQty = item.querySelector('input[name="quantity"]') ? item.querySelector('input[name="quantity"]').value : 1;
        const product = {
          id: productId,
          variantId: variantId,
          quantity: productQty,
          productPrice: productPrice,
          cartPrice: cartPrice
        }
        products.products.push(product);
      });
    }

    console.log('products', products)

    deliveryForm.classList.add('loader');
    deliveryWrap.innerHTML = '';
    hideTabs();
    clearTabs();
    

    setCookie("postcode", postCode.value);

    let errorMessage;
    if (postCode && postCode.value && postCode.value.trim() !== "") {
      errorMessage = `
          <div class="delivery-form__messages">
            <div class="delivery-form__messages-message">
              <p>
                Sorry, there was no delivery or pick up option available for your postcode. <a href="/contact">Contact us</a> now for a shipping rate.
              </p>
            </div>
          </div>`;
    } else {
      errorMessage = `
          <div class="delivery-form__messages">
            <div class="delivery-form__messages-message">
              <p>
                <!-- Please enter a postcode -->
              </p>
            </div>
          </div>
      `;
    }

    const currentUrl = `${baseUrl}/shipping/calculate/by-postcode/${postCode.value}`;
    const currentBody = JSON.stringify(products);
    const now = Date.now();

    // Check if this is a duplicate request (same URL and body) within the debounce time
    if (lastRequest.url === currentUrl && 
        lastRequest.body === currentBody && 
        (now - lastRequest.timestamp) < REQUEST_DEBOUNCE_MS) {
      console.log('Skipping duplicate request');
      return;
    }

    // Update last request data
    lastRequest = {
      url: currentUrl,
      body: currentBody,
      timestamp: now
    };

    fetch(currentUrl, {
      method: 'POST',
      body: currentBody,
      headers: {
        'Content-Type': 'application/json'
      },
      'mode': 'cors',
    })
      .then(response => response.json())
      .then(data => {
        clearTabs();
        showTabs();
        /*
        if (document.querySelector('shipping-calculator')) {
          document.querySelector('shipping-calculator').style.display = 'block';
        }
        */

        console.log('data', data)
        console.log('shopify URL: ' + window.Shopify.routes.root);
        deliveryForm.classList.remove('loader');
        deliveryWrap.insertAdjacentHTML('afterbegin', ``);
        const currencySymbol = document.querySelector('[data-currency-symbol]').getAttribute('data-currency-symbol');

        let shipping_cost = data.total;
        if (data.service_name) {
          data.service_name = data.service_name.replace('Dynamo ', '');
          var hasServiceName  = true;
        } else {
          var hasServiceName  = false;
        }
        var sectionId = getSectionId();

        var onDisplay = ``;
        if (data.onDisplay && data.onDisplay.length && data.onDisplay.length > 3) { // collapsable content
          onDisplay         = onDisplay + `
                                <div class="product-tab__item product-tab__item--see-it-on-display">
                                  <button is="toggle-button" class="heading h6 collapsible-toggle text--strong" aria-controls="block-see-it-on-display" aria-expanded="false">${eyeIcon} See It On Display ${collapseDownIcon}</button>
                                  <collapsible-content id="block-see-it-on-display" class="collapsible anchor" style="overflow: hidden">
                                    <div class="product-tab__content">
                                      `;

                                    
          data.onDisplay.forEach(onDisplayStore => {
            storeId         = onDisplayStore['store_id'];
            subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                              <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;
            onDisplay = onDisplay + `
              <div class="delivery-form__messages-row on-display collapsable">
                <p>
                    <!-- ${eyeIcon} -->
                    <span class="on-display-title-wrapper">
                      <!-- <span class="on-display-title">See It On Display</span> -->
                      <span class="on-display-store-name">${onDisplayStore['store_name']}</span>
                    </span>
                </p>
                <span class="mark">
                    ${subOptionTotal}
                </span>
              </div>`;
            }
          );

          onDisplay         = onDisplay + `
                                    </div>
                                  </collapsible-content>
                                </div>
              `;
        } else if (data.onDisplay && data.onDisplay.length) {
          data.onDisplay.forEach(onDisplayStore => {
            storeId         = onDisplayStore['store_id'];
            subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                              <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;
            onDisplay = onDisplay + `
              <div class="delivery-form__messages-row on-display">
                <p>
                    ${eyeIcon}
                    <span class="on-display-title-wrapper">
                      <span class="on-display-title">See It On Display</span>
                      <span class="on-display-store-name">${onDisplayStore['store_name']}</span>
                    </span>
                </p>
                <span class="mark">
                    ${subOptionTotal}
                </span>
              </div>`;
            }
          );

        }

        subOptionsHtml = subOptionDeliveryTab = subOptionInstoreTab = '';
        var pickupContentCount = 0;
        var pickupTab = `
                <div class="product-tab__item product-tab__item--see-it-on-display">
                  <button is="toggle-button" class="heading h6 collapsible-toggle text--strong" aria-controls="block-pickup-at" aria-expanded="false">${parentPickupIcon} Pickup at ${collapseDownIcon}</button>
                  <collapsible-content id="block-pickup-at" class="collapsible anchor" style="overflow: hidden">
                    <div class="product-tab__content">
                      `;
        if (data.subOptions && data.subOptions.length) {
          data.subOptions.forEach(subOption => {
              subOption.total = subOption.total !== undefined ? subOption.total : 0;
              subOptionTotal = subOption.total === 0 ? 'Free' : `${currencySymbol}${subOption.total.toFixed(2)}`;
              subOptionTitle = subOption.service_name;
              subOptionTab = subOption.tab !== undefined ? subOption.tab : 'delivery';
              console.log("SubOption tab: " + subOptionTab + " for " + subOptionTitle);
              storeId        = '';
              if (subOption['store_id']) {
                storeId     = subOption['store_id'];
              }
              noteClass = 'shipping-suboptions';
              pickupIcon = '';
              installIcon = '';
              thisAddClass = '';
              if (subOptionTitle.includes("Transfer")) {
                noteClass = noteClass + ' pickup';
                pickupTitle  = subOptionTitle;
                pickupStore  = '';
                if (subOptionTitle.includes("Transfer to Pickup at")) {
                  var pickupTitle = subOptionTitle.substring(0, 'Transfer to Pickup at'.length);
                  var pickupStore = subOptionTitle.substring('Transfer to Pickup at'.length).trim();
                }
                pickupIcon = parentPickupIcon;
                subOptionTitle = `<span class="pickup-title-wrapper">
                                    <span class="pickup-title">` + pickupTitle + `</span>
                                    <span class="pickup-store">` + pickupStore + `<span class="pickup-free">Free</span></span>
                                  </span>`;
                subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                  <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;

                pickupContentCount = pickupContentCount + 1;
                thisAddClass = 'remove-excess';
                pickupTab = pickupTab + `
                                  <div class="delivery-form__messages-row on-display pickup-transfer">
                                    <p>
                                        <span class="pickup-title-wrapper">
                                          <span class="pickup-store-name">${subOptionTitle}</span>
                                        </span>
                                    </p>
                                    <span class="mark">
                                        ${subOptionTotal}
                                    </span>
                                  </div>`;

                /* swap (i) icon and "free" label position */
                var container = document.createElement('div');
                container.innerHTML = subOptionTitle;
                if (container.querySelector('.transfer')) {
                  var pickupFree = container.querySelector('.pickup-free');
                  var pickupUnavailableTransfer = container.querySelector('.transfer');
                  pickupUnavailableTransfer.parentNode.insertBefore(pickupFree, pickupUnavailableTransfer);
                  subOptionTitle = container.innerHTML;
                }                                  
              } else if (subOptionTitle.includes("Warehouse")) {
                noteClass = noteClass + ' pickup';
                pickupTitle  = subOptionTitle;
                pickupStore  = '';
                if (subOptionTitle.includes("Warehouse")) {
                  var pickupTitle = subOptionTitle.substring(0, 'Pickup at'.length);
                  var pickupStore = subOptionTitle.substring('Pickup at '.length).trim();
                }
                pickupIcon = parentPickupIcon;
                subOptionTitle = `<span class="pickup-title-wrapper">
                                    <span class="pickup-title">` + pickupTitle + `</span>
                                    <span class="pickup-store">` + pickupStore + ` ` + cautionIcon + `<span class="pickup-free">Free</span></span>
                                  </span>`;
                subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                  <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;

                /* swap (i) icon and "free" label position */
                var container = document.createElement('div');
                container.innerHTML = subOptionTitle;
                if (container.querySelector('.transfer')) {
                  var pickupFree = container.querySelector('.pickup-free');
                  var pickupUnavailableTransfer = container.querySelector('.transfer');
                  pickupUnavailableTransfer.parentNode.insertBefore(pickupFree, pickupUnavailableTransfer);
                  subOptionTitle = container.innerHTML;
                }                                  
              } else if (subOptionTitle.includes("Pickup")) {
                noteClass = noteClass + ' pickup';
                var pickupTitle = subOptionTitle.substring(0, 'Pickup at'.length);
                var pickupStore = subOptionTitle.substring('Pickup at'.length).trim();

                pickupIcon = parentPickupIcon;
                subOptionTitle = `<span class="pickup-title-wrapper">
                                    <span class="pickup-title">` + pickupTitle + ` </span>
                                    <span class="pickup-store-name">` + pickupStore + ` <span class="pickup-free">Free</span></span>
                                  </span>`;
                subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                    <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;
                
                pickupContentCount = pickupContentCount + 1;
                thisAddClass = 'remove-excess';
                pickupTab = pickupTab + `
                                    <div class="delivery-form__messages-row on-display pickup">
                                      <p>
                                          <span class="pickup-title-wrapper">
                                            <span class="pickup-store-name">${pickupStore}</span>
                                            <span class="pickup-free">Free</span>
                                          </span>
                                      </p>
                                      <span class="mark">
                                          ${subOptionTotal}
                                      </span>
                                    </div>`;

              } else if (subOptionTitle.includes("Installation")) {
                let cleanTitle = subOptionTitle.replace(/<a[^>]*>.*?<\/a>/gi, '');
                
                noteClass = noteClass + ' installation';
                installTitle  = cleanTitle;
                installStore  = '';
                if (cleanTitle.includes("Delivery & Installation,")) {
                  var installTitle = cleanTitle.substring(0, 'Delivery & Installation, '.length);
                  installTitle = installTitle.replace(/,/g, '');
                  var installStore = cleanTitle.substring('Delivery & Installation, '.length).trim();
                }
                installStore = installStore.length > 0 
                  ? installStore.charAt(0).toUpperCase() + installStore.slice(1).toLowerCase()
                  : installStore;
                installIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="pip-svg-icon pip-services-section__icon"><g stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" fill="none" stroke="currentColor"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></g></svg>`;
                subOptionTitle = `<span class="install-title-wrapper">
                                    <span class="install-title">` + installTitle + `</span>
                                    <span class="install-store-name">` + installStore + `</span>
                                  </span>`;
              }

              
              thisSubOptionHtml = `<div class="delivery-form__messages-row shipping-suboptions ${thisAddClass}">
                                      <p>
                                        ${pickupIcon} ${installIcon}
                                        ${subOptionTitle}
                                      </p>
                                      <span class="mark">
                                        ${subOptionTotal}
                                      </span>
                                    </div>`;

              if ('instore' == subOptionTab) {
                subOptionInstoreTab = subOptionInstoreTab + thisSubOptionHtml;
              } else {
                subOptionDeliveryTab = subOptionDeliveryTab + thisSubOptionHtml;
              }
              subOptionsHtml  = subOptionsHtml + thisSubOptionHtml;
            }
          );
        }

        if (data.notes && data.notes.length) {
          data.notes.forEach(subOption => {
              thisAddClass = '';
              subOptionTitle = subOption.service_name;
              storeId        = '';
              if (subOption['store_id']) {
                storeId     = subOption['store_id'];
              }
              subOptionTab = subOption.tab !== undefined ? subOption.tab : 'delivery';
              subOptionTotal = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;
              noteClass = 'shipping-notes';
              pickupIcon = '';
              installIcon = '';
              if (subOptionTitle.includes("Pickup")) {
                noteClass = noteClass + ' pickup';

                var textPart = subOptionTitle.split("<")[0].trim(); // Get the text before the first HTML tag
                var htmlPart = subOptionTitle.substring(subOptionTitle.indexOf("<")).trim(); // Get everything from the first HTML tag onwards
                textPart = textPart.replace("Pickup at ", "");
                
                thisAddClass = 'remove-excess';
                pickupIcon = parentPickupIcon;
                subOptionTitle = `<span class="pickup-title-wrapper ${thisAddClass}"><span class="pickup-title">` + textPart + '</span>' + htmlPart + ` <span class="pickup-free">Free</span></span>`;

                pickupContentCount  = pickupContentCount + 1;
                pickupTab = pickupTab + `
                                  <div class="delivery-form__messages-row on-display pickup-unavailable">
                                    <p>
                                        <span class="pickup-title-wrapper">
                                          <span class="pickup-title">${textPart}</span>
                                          ${htmlPart} <span class="pickup-free">Free</span></span>
                                        </span>
                                    </p>
                                    <span class="mark">
                                        ${subOptionTotal}
                                    </span>
                                  </div>`;

                /* swap (i) icon and "free" label position */
                var container = document.createElement('div');
                container.innerHTML = subOptionTitle;
                if (container.querySelector('.pickup-unavailable.transfer')) {
                  var pickupFree = container.querySelector('.pickup-free');
                  var pickupUnavailableTransfer = container.querySelector('.pickup-unavailable.transfer');
                  pickupUnavailableTransfer.parentNode.insertBefore(pickupFree, pickupUnavailableTransfer);
                  subOptionTitle = container.innerHTML;
                } 
              } 
              if (subOptionTitle.includes("Installation")) {
                let cleanTitle = subOptionTitle.replace(/<a[^>]*>.*?<\/a>/gi, '');
                
                noteClass = noteClass + ' installation';
                installTitle  = cleanTitle;
                installStore  = '';
                if (cleanTitle.includes("Delivery & Installation,")) {
                  var installTitle = cleanTitle.substring(0, 'Delivery & Installation, '.length);
                  installTitle = installTitle.replace(/,/g, '');
                  var installStore = cleanTitle.substring('Delivery & Installation, '.length).trim();
                }
                installStore = installStore.length > 0 
                  ? installStore.charAt(0).toUpperCase() + installStore.slice(1).toLowerCase()
                  : installStore;
                installIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="pip-svg-icon pip-services-section__icon"><g stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" fill="none" stroke="currentColor"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></g></svg>`;
                subOptionTitle = `<span class="install-title-wrapper">
                                    <span class="install-title">` + installTitle + `</span> 
                                    <span class="install-store">` + installStore + `</span>
                                  </span>`;
              }
              
              thisSubOptionHtml = `<div class="delivery-form__messages-row ` + noteClass + `">
                                  <p>
                                    ${pickupIcon} ${installIcon}
                                    ${subOptionTitle}
                                  </p>
                                  <span class="mark">
                                    ${subOptionTotal}
                                  </span>
                                </div>`;

              if ('instore' == subOptionTab) {
                subOptionInstoreTab = subOptionInstoreTab + thisSubOptionHtml;
              } else {
                subOptionDeliveryTab = subOptionDeliveryTab + thisSubOptionHtml;
              }
              subOptionsHtml  = subOptionsHtml + thisSubOptionHtml;
            }
          );
        }

        
        if (pickupContentCount > 3) {
          pickupTab   = pickupTab + `
                              </div>
                            </collapsible-content>
                          </div>
                          `;
          subOptionInstoreTab = subOptionInstoreTab + pickupTab;

          // remove individual elements because we'll be using collapsable elements
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = subOptionInstoreTab;
          var excessElements = tempDiv.querySelectorAll('.remove-excess');
          excessElements.forEach(function(el) {
            var parentRow = el.closest('div.delivery-form__messages-row');
            if (parentRow) {
              parentRow.remove();
            }
          });
          subOptionInstoreTab = tempDiv.innerHTML;
        }
        

        stockInfo     = ``;
        if (data.stockStatus && data.stockStatus.status) {
          var sStatus = data.stockStatus.status;
          sStatus     = sStatus.trim();
          var sColor  = data.stockStatus.color ?? 'blue';
          sColor      = 'preorder';
          if ("In-Stock" === sStatus) {
            sColor    = 'green';
            sStatus   = "IN-STOCK NOW";
          }
          var sNote   = data.stockStatus.note ?? '';
          stockInfo   = stockInfo + `<div class="delivery-form__messages-row shipping-stock-status"><p class="stock-status ` + sColor + `"><span class="status-label">` + sStatus + `</span> ` + sNote + `</p></div>`;
          var stores  = data.stockStatus.stores ?? [];
          var storeLocations = '';
          var productStockInfoDiv = document.querySelector('.product .calculator-stock-status');
          if (productStockInfoDiv) {
            productStockInfoDiv.innerHTML = '';
          }
          if (sStatus !== "In-Stock" && sStatus !== "Out of stock" && sStatus !== "IN-STOCK NOW") {
            if (productStockInfoDiv) {
              //productStockInfoDiv.innerHTML = stockInfo;
            }
            /* add line item entry */
            var addToCartButton = document.querySelector('button#AddToCart');
            if (addToCartButton) {
              var formElement = addToCartButton.closest('form');
              var preOrderNote = document.querySelector('#pre-order-note');
              if (false) {
                if (!preOrderNote) {
                    var input = document.createElement('input');
                    input.setAttribute('type', 'hidden');
                    input.setAttribute('id', 'pre-order-note');
                    input.setAttribute('value', sNote);
                    input.setAttribute("name", "properties[Pre-order]")
                    formElement.appendChild(input);
                    console.log("Adding");
                } else {
                    preOrderNote.setAttribute("value", sNote);
                    console.log("updating");
                }
              }
            }



            if (stores.length) {
              storeLocations = `<div class="delivery-form__messages-row"><table class="stock-stores"><thead><tr><td>Store</td><td>Available</td><tr></thead><tbody>`;
            }
            for (var i = 0; i < stores.length; i++) {
              var store = stores[i];
              var name = store.name;
              var province = store.province_code;
              var available = store.available;
              //storeLocations = storeLocations + ' ' + name + ' (' + province + ') Available: ' + available + ' <br/>';
              storeLocations = storeLocations + '<tr><td>' + name + ' (' + province + ') </td><td>' + available + '</td></tr>';
            }
            if (stores.length) {
              storeLocations  = storeLocations + `</tbody></table></div>`;
            }
          } else {
            // do not show In-Stock
            stockInfo   = '';
          }
          // do not show stock availablity
          //stockInfo   = stockInfo + storeLocations;
        } else {
          if (!data.stockStatus) {
            console.log("No stockStatus");
          }
          if (!data.stockStatus || !data.stockStatus.length) {
            console.log("No stockStatus length");
          }
          if (!data.stockStatus || !data.stockStatus.status) {
            console.log("No stockStatus status");
          }
        }
        
        var serviceName = data.service_name ? data.service_name : 'Delivery';
        var showNoDelivery = data.showNoDelivery ? data.showNoDelivery : '0';
        
        let listAddresses = [];
        const unavailableProducts = [];
        const newAddresses = [];

        data.products.forEach(product => {
          if(product.addresses.length > 0) {
            const address = product.addresses;
            const productInfo = {address: address, product_id: product.product_id}
            listAddresses.push(productInfo)
          } else {
            const productElement = document.querySelector(`[data-delivery-products='${product.product_id}']`);
            const unavailable = productElement ? productElement.getAttribute('data-delivery-product-name') : `Product ${product.product_id}`;
            unavailableProducts.push(unavailable);
          }
        })

        if (data.restrictedProducts && data.restrictedProducts.length) {
          data.restrictedProducts.forEach(restrictedProduct => {
              if (document.querySelector(`[data-delivery-products='${restrictedProduct}']`)) {
                  if (document.querySelector(`[data-delivery-products='${restrictedProduct}']`).querySelector(`[class='line-item__info']`)) {
                      document.querySelector(`[data-delivery-products='${restrictedProduct}']`).querySelector(`[class='line-item__info']`).innerHTML += '<strong>Unavailable</strong>';
                  }
              }
          });
        }

        if(false && listAddresses.length && !unavailableProducts.length) {
          listAddresses[0].address.forEach(item =>{
            newAddresses.push(
              `<div class="delivery-form__pickup">
          
          ${item.location.name ? '<p><b>Pick up available at</b> '+ item.location.name + '</p>' : ''}
            <p><b>Store address:</b></p>
            ${item.location.address1 ? item.location.address1 : ''}<br>
            ${item.location.city ? item.location.city : ''} ${item.location.zip ? item.location.zip : ''}<br>
            ${item.location.country ? item.location.country : ''}
            ${item.location.phone ? '<p><b>Phone:</b> <a href="tel:' + item.location.phone + '"></a></p> ' + item.location.phone : ''}
          </div>`)
          })
        }

        if (hasServiceName) {
          shipping_cost = shipping_cost === 0 ? 'Free' : `${currencySymbol}${shipping_cost.toFixed(2)}`
                  
          let tempDiv = document.createElement("span");
          tempDiv.className = "pickup-title-wrapper";
          tempDiv.innerHTML = serviceName;

          let elements = tempDiv.querySelectorAll(".service-name");
          if (elements.length > 0) {
            elements.forEach((el, index) => {
              serviceNameText = el.innerHTML;
              if (serviceNameText.includes("-")) {
                var splittedText = serviceNameText.split("-");
                serviceNameText = splittedText[0];
                serviceNameDesc = splittedText[1];
                el.innerHTML = serviceNameText;
                el.classList.add("pickup-title");

                // Create new <span> element
                let descSpan = document.createElement("span");
                descSpan.className = "pickup-unavailable-caption";
                descSpan.innerHTML = serviceNameDesc;

                // Insert it after `el` as a sibling
                el.after(descSpan);
              } else {
                serviceName   = deliveryIcon + serviceName;
              }
            });
            serviceName = deliveryIcon + tempDiv.outerHTML;
          } else {
            serviceName   = deliveryIcon + serviceName;
          }

        } else {
          shipping_cost = "";
          serviceName = "";
        }

        let unavailableProductsString = '';

        if (unavailableProducts.length) {
          unavailableProducts.forEach(item => {
            unavailableProductsString += `<p>- ${item}</p>`;
          });
        }

        

        if(
          (data.products.length && listAddresses.length && !unavailableProducts.length) 
          || (data.products.length && hasServiceName)
          
        ) { 
          if ("1" == showNoDelivery) {
              if (data.noShippingReason) {
                noDeliveryMessage   = data.noShippingReason;
              }
              thisDeliveryHtml = `<div class="delivery-form__messages-row shipping-no-delivery">
                                        <p class="shipping-no-delivery">
                                            ${deliveryIcon} 
                                            <span class="so-title-wrapper">
                                              ${noDeliveryMessage}
                                            </span>
                                        </p>
                                    </div>`;

              appendTab(stockInfo, 'instore');
              appendTab(stockInfo, 'delivery');
              appendTab(onDisplay, 'instore');
              appendTab(thisDeliveryHtml, 'delivery');
              appendTab(subOptionDeliveryTab, 'delivery');
              appendTab(subOptionInstoreTab, 'instore');
              if (false && !isProductPage()) {
                deliveryWrap.insertAdjacentHTML('afterbegin', `
                                            <div class="delivery-form__messages">
                                                <div class="delivery-form__messages-message">
                                                    ${stockInfo}
                                                    ${onDisplay}
                                                    ${thisDeliveryHtml}
                                                    ${subOptionsHtml}
                                                </div>
                                            </div>
                                            ${newAddresses.join('')}
                                        `);
                }
          } else {
            thisDeliveryHtml = `<div class="delivery-form__messages-row shipping-options">
                                    <p>
                                        ${serviceName}
                                    </p>
                                    <span class="mark">
                                        ${shipping_cost}
                                    </span>
                                </div>`;
              appendTab(stockInfo, 'instore');
              appendTab(stockInfo, 'delivery');
              appendTab(onDisplay, 'instore');
              appendTab(thisDeliveryHtml, 'delivery');
              appendTab(subOptionDeliveryTab, 'delivery');
              appendTab(subOptionInstoreTab, 'instore');
              if (false && !isProductPage()) {
                deliveryWrap.insertAdjacentHTML('afterbegin', `
                                            <div class="delivery-form__messages">
                                                <div class="delivery-form__messages-message">
                                                    ${stockInfo}
                                                    ${onDisplay}
                                                    ${thisDeliveryHtml}
                                                    ${subOptionsHtml}
                                                </div>
                                            </div>
                                            ${newAddresses.join('')}
                                        `);
              }
          }
      } else {
          console.log("Length", data.products.length);
          if (data.noShippingReason) {
              noDeliveryMessage   = data.noShippingReason;
              console.log("noDeliveryMessage: " + noDeliveryMessage);
          } else {
              console.log("Empty Reason");
          }
          thisDeliveryHtml = `<div class="delivery-form__messages-row shipping-no-delivery">
                                  <p class="shipping-no-delivery">
                                      ${deliveryIcon} 
                                      <span class="so-title-wrapper">
                                        ${noDeliveryMessage}
                                      </span>
                                  </p>
                              </div>`;
          appendTab(stockInfo, 'instore');
          appendTab(stockInfo, 'delivery');
          appendTab(onDisplay, 'instore');
          appendTab(thisDeliveryHtml, 'delivery');
          appendTab(subOptionDeliveryTab, 'delivery');
          appendTab(subOptionInstoreTab, 'instore');
          if (false && !isProductPage()) {
            deliveryWrap.insertAdjacentHTML('afterbegin', `
                                            <div class="delivery-form__messages">
                                                <div class="delivery-form__messages-message">
                                                    ${stockInfo}
                                                    ${onDisplay}
                                                    ${thisDeliveryHtml}
                                                    ${subOptionsHtml}
                                                </div>
                                            </div>
            `);
          }
      }
        deliveryForm.classList.remove('loader');
      })
      .catch(error => {
        console.error(error);
        deliveryWrap.insertAdjacentHTML('afterbegin', errorMessage);
        deliveryForm.classList.remove('loader');
      });


      var isCartPage = document.querySelector('cart-items-component .cart-items');
      if (isCartPage) {
        if (products.products.length > 1) {
          if (true) {
            var pickupDetailsRows = document.querySelectorAll('tr.pickup-details');
            pickupDetailsRows.forEach(function(row) {
                row.remove();
            })

            fetch(`${baseUrl}/shipping/pickup/by-postcode/${postCode.value}`, {
              method: 'POST',
              body: JSON.stringify(products),
              headers: {
                'Content-Type': 'application/json'
              },
              'mode': 'cors',
            })
            .then(response => response.json())
            .then(data => {
              console.log("pickup data: " + data);
              for (var i = 0; i < data.length; i++) {
                  var subOptionsHtml  = '';
                  var productId = data[i].product;
                  console.log("Product:", data[i].product);
                  var deliveryRow = document.querySelector('tr[data-delivery-products="' + productId + '"]');
                  var newRow = document.createElement('tr');
                  newRow.setAttribute('data-delivery-products-child', productId);
                  newRow.setAttribute('class', 'pickup-details');
                  newRow.innerHTML = '<td colspan="3" data-delivery-products-child="' + productId + '"></td>';
                  if (deliveryRow && deliveryRow.parentNode) {
                      deliveryRow.parentNode.insertBefore(newRow, deliveryRow.nextSibling);
                  }

                  stockInfo     = ``;
                  if (data[i].stockStatus && data[i].stockStatus.status) {
                    var sStatus = data[i].stockStatus.status;
                    sStatus     = sStatus.trim();
                    var sColor  = data[i].stockStatus.color ?? 'blue';
                    var ooNote  = data[i].stockStatus['on-order-note'] ?? '';
                    sColor      = 'preorder';
                    if ("In-Stock" === sStatus) {
                      sColor    = 'green';
                      sStatus   = "IN-STOCK NOW";
                    }
                    var sNote   = data[i].stockStatus.note ?? '';
                    stockInfo   = stockInfo + `<div class="delivery-form__messages-row shipping-stock-status shipping-suboptions"><p class="stock-status ` + sColor + `"><span class="status-label">` + sStatus + `</span> ` + sNote + `</p></div>`;
                    subOptionsHtml = subOptionsHtml + stockInfo;
                  }
                    
                  
                  if (data[i].subOptions && data[i].subOptions.length) {
                    data[i].subOptions.forEach(subOption => {
                        subOption.total = subOption.total !== undefined ? subOption.total : 0;
                        subOptionTotal = subOption.total === 0 ? 'Free' : `${currencySymbol}${subOption.total.toFixed(2)}`;
                        subOptionTitle = subOption.service_name;
                        subOptionTab = subOption.tab !== undefined ? subOption.tab : 'delivery';
                        storeId        = '';
                        if (subOption['store_id']) {
                          storeId     = subOption['store_id'];
                        }
                        noteClass = 'shipping-suboptions';
                        pickupIcon = '';
                        installIcon = '';
                        if (subOptionTitle.includes("Transfer")) {
                          noteClass = noteClass + ' pickup';
                          pickupTitle  = subOptionTitle;
                          pickupStore  = '';
                          if (subOptionTitle.includes("Transfer to Pickup at")) {
                            var pickupTitle = subOptionTitle.substring(0, 'Transfer to Pickup at'.length);
                            var pickupStore = subOptionTitle.substring('Transfer to Pickup at'.length).trim();
                          }
                          pickupIcon = parentPickupIcon;
                          subOptionTitle = `<span class="pickup-title-wrapper">
                                              <span class="pickup-title">` + pickupTitle + `</span>
                                              <span class="pickup-store">` + pickupStore + `<span class="pickup-free">Free</span></span>
                                            </span>`;
                          subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                            <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;

                          /* swap (i) icon and "free" label position */
                          var container = document.createElement('div');
                          container.innerHTML = subOptionTitle;
                          if (container.querySelector('.transfer')) {
                            var pickupFree = container.querySelector('.pickup-free');
                            var pickupUnavailableTransfer = container.querySelector('.transfer');
                            pickupUnavailableTransfer.parentNode.insertBefore(pickupFree, pickupUnavailableTransfer);
                            subOptionTitle = container.innerHTML;
                          }                                  
                        } else if (subOptionTitle.includes("Warehouse")) {
                          noteClass = noteClass + ' pickup';
                          pickupTitle  = subOptionTitle;
                          pickupStore  = '';
                          if (subOptionTitle.includes("Pickup at")) {
                            var pickupTitle = subOptionTitle.substring(0, 'Pickup at'.length);
                            var pickupStore = subOptionTitle.substring('Pickup at'.length).trim();
                          }
                          pickupIcon = parentPickupIcon;
                          subOptionTitle = `<span class="pickup-title-wrapper">
                                              <span class="pickup-title">` + pickupTitle + `</span>
                                              <span class="pickup-store">` + pickupStore + ` ` + cautionIcon + `<span class="pickup-free">Free</span></span>
                                            </span>`;
                          subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                            <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;

                          /* swap (i) icon and "free" label position */
                          var container = document.createElement('div');
                          container.innerHTML = subOptionTitle;
                          if (container.querySelector('.transfer')) {
                            var pickupFree = container.querySelector('.pickup-free');
                            var pickupUnavailableTransfer = container.querySelector('.transfer');
                            pickupUnavailableTransfer.parentNode.insertBefore(pickupFree, pickupUnavailableTransfer);
                            subOptionTitle = container.innerHTML;
                          }                                  
                        } else if (subOptionTitle.includes("Pickup")) {
                          noteClass = noteClass + ' pickup';
                          var pickupTitle = subOptionTitle.substring(0, 'Pickup at'.length);
                          var pickupStore = subOptionTitle.substring('Pickup at'.length).trim();

                          pickupIcon = parentPickupIcon;
                          subOptionTitle = `<span class="pickup-title-wrapper">
                                              <span class="pickup-title">` + pickupTitle + ` </span>
                                              <span class="pickup-store-name">` + pickupStore + ` <span class="pickup-free">Free</span></span>
                                            </span>`;
                          subOptionTotal  = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                              <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;

                        } else if (subOptionTitle.includes("Installation")) {
                          // Clean up the title by removing any store-specific links
                          let cleanTitle = subOptionTitle.replace(/<a[^>]*>.*?<\/a>/gi, '');
                          
                          noteClass = noteClass + ' installation';
                          installTitle  = cleanTitle;
                          installStore  = '';
                          if (cleanTitle.includes("Delivery & Installation,")) {
                            var installTitle = cleanTitle.substring(0, 'Delivery & Installation, '.length);
                            installTitle = installTitle.replace(/,/g, '');
                            var installStore = cleanTitle.substring('Delivery & Installation, '.length).trim();
                          }
                          installStore = installStore.length > 0 
                            ? installStore.charAt(0).toUpperCase() + installStore.slice(1).toLowerCase()
                            : installStore;
                          installIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="pip-svg-icon pip-services-section__icon"><g stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" fill="none" stroke="currentColor"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></g></svg>`;
                          subOptionTitle = `<span class="install-title-wrapper">
                                              <span class="install-title">` + installTitle + `</span>
                                              <span class="install-store-name">` + installStore + `</span>
                                            </span>`;
                        }
                        thisSubOptionHtml = `<div class="delivery-form__messages-row shipping-suboptions">
                                              <p>
                                                ${pickupIcon} ${installIcon}
                                                ${subOptionTitle}
                                              </p>
                                              <span class="mark">
                                                ${subOptionTotal}
                                              </span>
                                            </div>`;
                        if ('delivery' == subOptionTab) {
                          subOptionDeliveryTab = subOptionDeliveryTab + thisSubOptionHtml;
                        } else {
                          if (typeof subOptionInstoreTab === 'undefined' || subOptionInstoreTab === null) {
                            subOptionInstoreTab = '';
                          }
                          subOptionInstoreTab = subOptionInstoreTab + thisSubOptionHtml;
                        }
                        subOptionsHtml  = subOptionsHtml + thisSubOptionHtml;
                      }
                    );
                  }

                  if (data[i].notes && data[i].notes.length) {
                    data[i].notes.forEach(subOption => {
                        subOptionTitle = subOption.service_name;
                        subOptionTab = subOption.tab !== undefined ? subOption.tab : 'delivery';
                        storeId        = '';
                        if (subOption['store_id']) {
                          storeId     = subOption['store_id'];
                        }
                        subOptionTotal = `<button is="toggle-button" class="product-meta__help link text--subdued hidden-phone" aria-controls="${storeId}-shipcalc-drawer" aria-expanded="false">${arrowIcon}</button>
                                          <button is="toggle-button" class="product-meta__help link text--subdued hidden-tablet-and-up" aria-controls="${storeId}-shipcalc-popover" aria-expanded="false">${arrowIcon}</button>`;
                        noteClass = 'shipping-notes';
                        pickupIcon = '';
                        installIcon = '';
                        if (subOptionTitle.includes("Pickup")) {
                          noteClass = noteClass + ' pickup';

                          var textPart = subOptionTitle.split("<")[0].trim(); // Get the text before the first HTML tag
                          var htmlPart = subOptionTitle.substring(subOptionTitle.indexOf("<")).trim(); // Get everything from the first HTML tag onwards
                          
                          pickupIcon = parentPickupIcon;
                          subOptionTitle = `<span class="pickup-title-wrapper"><span class="pickup-title">` + textPart + '</span>' + htmlPart + ` <span class="pickup-free">Free</span></span>`;

                          /* swap (i) icon and "free" label position */
                          var container = document.createElement('div');
                          container.innerHTML = subOptionTitle;
                          if (container.querySelector('.pickup-unavailable.transfer')) {
                            var pickupFree = container.querySelector('.pickup-free');
                            var pickupUnavailableTransfer = container.querySelector('.pickup-unavailable.transfer');
                            pickupUnavailableTransfer.parentNode.insertBefore(pickupFree, pickupUnavailableTransfer);
                            subOptionTitle = container.innerHTML;
                          } 
                        } 
                        if (subOptionTitle.includes("Installation")) {
                          // Clean up the title by removing any store-specific links
                          let cleanTitle = subOptionTitle.replace(/<a[^>]*>.*?<\/a>/gi, '');
                          
                          noteClass = noteClass + ' installation';
                          installTitle  = cleanTitle;
                          installStore  = '';
                          if (cleanTitle.includes("Delivery & Installation,")) {
                            var installTitle = cleanTitle.substring(0, 'Delivery & Installation, '.length);
                            installTitle = installTitle.replace(/,/g, '');
                            var installStore = cleanTitle.substring('Delivery & Installation, '.length).trim();
                          }
                          installStore = installStore.length > 0 
                            ? installStore.charAt(0).toUpperCase() + installStore.slice(1).toLowerCase()
                            : installStore;
                          installIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="pip-svg-icon pip-services-section__icon"><g stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" fill="none" stroke="currentColor"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></g></svg>`;
                          subOptionTitle = `<span class="install-title-wrapper">
                                              <span class="install-title">` + installTitle + `</span> 
                                              <span class="install-store">` + installStore + `</span>
                                            </span>`;
                        }
                        thisSubOptionHtml = `<div class="delivery-form__messages-row ` + noteClass + `">
                                              <p>
                                                ${pickupIcon} ${installIcon}
                                                ${subOptionTitle}
                                              </p>
                                              <span class="mark">
                                                ${subOptionTotal}
                                              </span>
                                            </div>`;
                        if (typeof subOptionInstoreTab === 'undefined') {
                          subOptionInstoreTab = '';
                        }
                        if ('instore' == subOptionTab) {
                          subOptionInstoreTab = subOptionInstoreTab + thisSubOptionHtml;
                        } else {
                          subOptionDeliveryTab = subOptionDeliveryTab + thisSubOptionHtml;
                        }
                        subOptionsHtml  = subOptionsHtml + thisSubOptionHtml;
                      }
                    );
                  }

                  var tdRow = document.querySelector('td[data-delivery-products-child="' + productId + '"]');
                  if (tdRow) {
                    tdRow.innerHTML = `<div class="pickup-details__wrapper">` + subOptionsHtml + `</div>`;
                  }
              }
            })
            .catch(error => {
              console.error(error);
              //deliveryWrap.insertAdjacentHTML('afterbegin', errorMessage);
              deliveryForm.classList.remove('loader');
            });
          }
        } 
        

      }
      
  }

  function setCookie(name, value) {
    var days = 7;
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  function getSectionId() {
    var element = document.querySelector(".shipcalc-drawer");
    if (element && element.hasAttribute("sectionid")) {
        var sectionIdValue = element.getAttribute("sectionid");      
        return sectionIdValue;
    } 
    return false;
  }

  function isProductPage() {
    return !!document.querySelector("div.product__info");
  }

  function getTab(tabId) {
    if ('instore' == tabId) {
      tabId = 'tab-instore-' + globalInstanceId;
    } else {
      tabId = 'tab-delivery-' + globalInstanceId;
    }
    return document.querySelector("#" + tabId + " div.delivery-form__messages-message");    
  }

  function clearTabs() {
    var tabEle = getTab('instore');
    if (tabEle) {
      tabEle.innerHTML = '';
    }
    tabEle = getTab('delivery');
    console.log("clear: " + globalInstanceId);
    if (tabEle) {
      tabEle.innerHTML = '';
    }
  }

  function appendTab(addContent, tabId) {
    var tabEle = getTab(tabId);
    if (tabEle) {
      var tabContent = tabEle.innerHTML + addContent;
      tabEle.innerHTML = tabContent;
      document.querySelector("shipping-calculator[data-instance-id='" + globalInstanceId + "']").removeAttribute('hidden');
    }    
  }

  function showTabs() {
    if (document.querySelector('shipping-calculator')) {
      document.querySelector('shipping-calculator').removeAttribute('hidden');
    }
  }

  function hideTabs() {
    if (document.querySelector('shipping-calculator')) {
      document.querySelector('shipping-calculator').setAttribute('hidden', '');
    }
  }

  function calculatorDomLoaded() {
    var isCartPage = document.querySelector('cart-items-component .cart-items');
    if (isCartPage) {
      if (!document.querySelector('body').hasAttribute('cart-dom-loaded')) {
        document.querySelector('body').setAttribute('cart-dom-loaded', 'true'); 
      } else {
        //return;
      }
    }

    console.log('DOM fully loaded and parsed');
    hideTabs();

    calculateBtn = null; //document.getElementById('calculate-shipping');
    calculateBtns = document.querySelectorAll('.calculate-shipping');
    postCode = document.getElementById('estimate_postcode');
    postCodes = document.querySelectorAll('.estimate_postcode');

    dataEl = document.querySelector('[data-component-product]');
    productData = dataEl ? JSON.parse(dataEl.textContent) : {};

    calculateBtns.forEach(button => {
      if (!button.hasAttribute('data-has-listener')) {
        button.setAttribute('data-has-listener', 'true');
        button.addEventListener('click', event => eventDelivery(event));
      }
    });

    postCodes.forEach(postCodeElement => {
      if (!postCodeElement.hasAttribute('data-has-listener')) {
        postCodeElement.setAttribute('data-has-listener', 'true');
        postCodeElement.addEventListener("keyup", function(event) {
          if (event.keyCode === 13) {
            eventDelivery(event)
          }
        });
      }
    });


    var calculatorFormElement = document.querySelector('div.product-form__delivery-pickup');
    var calculatorFormIsHidden = false;
    if (calculatorFormElement) {
      calculatorFormIsHidden = window.getComputedStyle(calculatorFormElement).display === 'none';
    } 
    
    if (!calculatorFormIsHidden) {
      var savedPostcode = getCookie("postcode");
      if (false &&savedPostcode) {
        var pc = document.querySelectorAll('.estimate_postcode');
        if (pc) {
          pc.forEach(p => p.value = savedPostcode);  
          if(calculateBtn) {
            calculateBtn.click();
          }
          calculateBtns.forEach(button => {
            if (!button.closest('.cart-drawer')) {
              button.click();  
            }            
          });
        }
      } else {

        var productStockInfoDiv = document.querySelector('.product .calculator-stock-status');
        if (false && productStockInfoDiv) {
          var stockPh = `
            <div class="delivery-form__messages">
                <div class="delivery-form__messages-message">
                    <div class="delivery-form__messages-row shipping-options">
                        <p>
                            ${deliveryIcon} 
                            <span class="so-title-wrapper">
                              <span class="so-title">Delivery</span>
                              <span class="so-subtitle">Check delivery availability</span>
                            </span>
                        </p>
                        <span class="mark">
                            <a href="#" onclick="
                                              var elem = document.getElementById('estimate_postcode');
                                              elem.focus(); 
                                              window.scrollTo({
                                                  top: elem.getBoundingClientRect().top + window.pageYOffset - 400, 
                                                  behavior: 'smooth'
                                              });
                                              return false;
                            ">${arrowIcon}</a>
                        </span>
                    </div>
                    
                </div>
            </div>`;
          productStockInfoDiv.innerHTML = stockPh;  
        }
      }


      
      // on variant change
      const radios = document.querySelectorAll('variant-picker input[type="radio"]');
      radios.forEach(radio => {
          console.log("Radio: " + radio.getAttribute("name"));
          radio.addEventListener('change', function() {
            var savedPostcode = getCookie("postcode");
            if (savedPostcode) {

              setTimeout(() => {
                calculateBtns.forEach(button => {
                  if (!button.closest('.cart-drawer')) {
                    button.click();  
                  }            
                });
              }, 500);
              
              /*
              var pc = document.getElementById('estimate_postcode');
              if (pc) {
                pc.value = savedPostcode;
                if(calculateBtn) {
                  setTimeout(() => {
                    calculateBtn.click();  
                  }, 500);
                }
              }
                */
            }
          });
      });

      if (document.querySelector("product-form-component")) { // product page
        console.log("product page");
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
          console.log("quantity input found");
          let lastQuantity = quantityInput.value;
          const checkQuantity = setInterval(() => {
            if (quantityInput.value !== lastQuantity) {
              console.log("quantity changed to", quantityInput.value);
              lastQuantity = quantityInput.value;
              var savedPostcode = getCookie("postcode");
              if (false && savedPostcode) {
                setTimeout(() => {
                  calculateBtns.forEach(button => {
                    if (!button.closest('.cart-drawer')) {
                      button.click();  
                    }            
                  });
                }, 500);
              }
            }
          }, 300); // Check every 300ms
          
          // Clean up the interval when the page unloads
          window.addEventListener('beforeunload', () => {
            clearInterval(checkQuantity);
          });
        }
      }

      


      var isCartPage = document.querySelector('cart-items-component .cart-items');
      if (isCartPage) {
        if (true) {
          // Check if listener is already added using a data attribute
          if (window.cartMonitorInitialized) {
              return; // Exit if already initialized
          }
          window.cartMonitorInitialized = true;

          // Store initial state of inputs and row count
          let initialQuantities = new Map();
          let initialRowCount = document.querySelectorAll('.cart-items__table-row').length;

          // Get all quantity inputs
          const inputs = document.querySelectorAll('input[name="updates[]"]');
          console.log("Inputs: " + inputs.length);
          
          // Initialize quantities map with current values
          inputs.forEach((input, index) => {
              initialQuantities.set(index, input.value);
          });

          // Check for changes every 1 second
          setInterval(() => {
              // Check for quantity changes
              inputs.forEach((input, index) => {
                  const currentValue = input.value;
                  if (initialQuantities.get(index) !== currentValue) {
                      console.log(`Quantity changed for item ${index + 1}: from ${initialQuantities.get(index)} to ${currentValue}`);
                      setTimeout(() => {
                          calculatorDomLoaded();
                      }, 2000);
                      initialQuantities.set(index, currentValue);
                  }
              });

              // Check for removed items
              const currentRowCount = document.querySelectorAll('.cart-items__table-row').length;
              if (currentRowCount < initialRowCount) {
                  console.log(`Item removed: ${initialRowCount - currentRowCount} item(s) removed from cart`);
                  setTimeout(() => {
                      calculatorDomLoaded();
                  }, 2000);
                  initialRowCount = currentRowCount;
                  // Update quantities map for remaining inputs
                  initialQuantities = new Map();
                  document.querySelectorAll('input[name="updates[]"]').forEach((input, index) => {
                      initialQuantities.set(index, input.value);
                  });
              }
          }, 1000);
        }
      



        setInterval(function() {
          if (false) {
            document.querySelectorAll('quantity-selector-component input[name="updates[]"]').forEach(function(input) {
              if (!input.hasAttribute('data-has-listener')) {
                input.setAttribute('data-has-listener', 'true');
                console.log("Added attribute and event. Value: " + input.value);
                input.addEventListener('change', function() {
                  console.log ("quantity changed");
                  calculatorDomLoaded();
                });
              }
            });
          }
        }, 1000);
        
      } else { // probably the product page.
        // add quantity change listener
        console.log("Product Page");
      }

    }
  }

  if(calculateBtn) {
    calculateBtn.addEventListener('click', event => eventDelivery(event))
  }

  calculateBtns.forEach(button => {
    if (!button.hasAttribute('data-has-listener')) {
      button.addEventListener('click', event => eventDelivery(event));
      button.setAttribute('data-has-listener', 'true');
    }
  });
  

  if (postCode) {
    postCode.addEventListener("keyup", function(event) {
      if (event.keyCode === 13) {
        eventDelivery(event)
      }
    });
  }

  postCodes.forEach(postCodeElement => {
    if (!postCodeElement.hasAttribute('data-has-listener')) {
      postCodeElement.addEventListener("keyup", function(event) {
        if (event.keyCode === 13) {
          eventDelivery(event)
        }
        postCodeElement.setAttribute('data-has-listener', 'true');
      });
    }
  });

  document.addEventListener('click', function(event) {
    // Check if the clicked element or its parent has the add-to-cart-button class
    const addToCartButton = event.target.closest('.add-to-cart-button');
    
    if (addToCartButton) {
      //handleAddToCartClick(event, addToCartButton);
      setTimeout(calculatorDomLoaded, 4000);
    }
  });


  document.addEventListener('DOMContentLoaded', function() {
    calculatorDomLoaded();
  });








})();


